import React from 'react';
import PropTypes from 'prop-types';

import { Table, Column, SortIndicator } from 'react-virtualized';
import { LinkButton } from 'shared/Buttons';

const SubmittalsTable = ({ data, registerChild, nameRenderer, dateRenderer, ...rest }) => {
  const rowGetter = ({ index }) => {
    return data[index] || {};
  };

  const tableProps = {
    ...rest,
    headerHeight: 55,
    rowHeight: 55,
    rowGetter,
    rowClassName: 'table-row',
    headerClassName: 'table-header',
    girdClassName: 'table__visible-items',
    scrollToAlignment: 'start'
  };

  const headerRenderer = ({ label, dataKey, sortBy, sortDirection }) => (
    <div>
      {label}
      {sortBy === dataKey && <SortIndicator {...{ sortDirection }} />}
    </div>
  );

  const projectNameRenderer = ({ rowData }) => {
    const { projectId, projectName } = rowData;
    return projectId ? (
      <LinkButton to={`/insights/projects/${projectId}`}>{projectName}</LinkButton>
    ) : null;
  };

  return (
    <Table {...tableProps} ref={registerChild}>
      <Column
        dataKey="date"
        label="Date"
        cellRenderer={dateRenderer}
        headerRenderer={headerRenderer}
        width={250}
        flexGrow={0}
      />
      <Column
        dataKey="name"
        label="Name"
        cellRenderer={nameRenderer}
        headerRenderer={headerRenderer}
        width={250}
        flexGrow={0}
      />
      <Column
        dataKey="company"
        label="Company"
        headerRenderer={headerRenderer}
        width={250}
        flexGrow={0}
      />
      <Column
        dataKey="projectName"
        label="Project Name"
        headerRenderer={headerRenderer}
        cellRenderer={projectNameRenderer}
        width={350}
        flexGrow={1}
      />
    </Table>
  );
};

SubmittalsTable.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      date: PropTypes.string,
      name: PropTypes.string,
      company: PropTypes.string,
      projectName: PropTypes.string,
      projectId: PropTypes.string
    })
  ).isRequired,
  registerChild: PropTypes.any
};

SubmittalsTable.defaultTypes = {
  data: []
};

export default SubmittalsTable;
